import { Formatters } from '../modules'

export const FIELD_ROOM_ID = () => ({
  label: '房号',
  formatter(room_id) {
    const room = this.$store.getters.room_by_id(room_id) || {}
    return room.no || '-'
  },
  classes: 'collapsing',
  innerClasses: 'navto-room',
  type: 'select',
  select() {
    return this.$store.state.summary.rooms.map(r => ({ key: r._id, label: r.no }))
  },
  onclick(record) {
    this.$router.$go.room({ id: record._room, _contract: record._contract })
  },
  sortable: true,
})

export const FIELD_PAYMENT = (label = '付款方式') => ({
  label,
  classes: 'collapsing center aligned hide-in-mobile',
  type: 'select',
  formatter(key) {
    return Formatters.payment_method(key, this.$store.state.summary.payment_methods)
  },
  select() {
    return this.$store.state.summary.payment_methods.map(({ name, display }) => ({ key: name, label: display }))
  },
})

export const FIELD_USER = (label = '操作员') => ({
  label,
  formatter(key) {
    return this.$store.getters.username(key)
  },
})

export const FIELD_TIME = (field = 'time_created', options) => ({
  label: '建立时间',
  type: 'time',
  classes: 'collapsing hide-in-mobile',
  sortable: true,
  readonly(record, form) {
    return form && form._id
  },
  ...options,
})

export const FIELD_CONTRACT_CUSTOMER = (field = '_contract', options) => ({
  label: '租户',
  classes: 'hide-in-mobile collapsing',
  maxlength: 8,
  tooltip: 'top center',
  formatter(_, record) {
    let customers = []
    const contract = this.$store.getters.contract(record[field])
    if (contract) {
      if (contract._customers && typeof contract._customers[0] === 'string')
        customers = this.$store.getters.customers_filter(contract._customers)
      else
        customers = contract._customers
    }
    return Formatters.customers_summary(customers)
  },
  ...options,
})

export const FILTERS_SELECT_DATE = (field = 'time_created') => ({
  type: 'daterange',
  field,
  selects: [{
    name: null,
    label: '全部',
  },
  {
    name: 'today',
    label: '今天',
  },
  {
    name: 'yesterday',
    label: '昨天',
  },
  {
    name: 'thismonth',
    label: '本月',
  },
  {
    name: 'lastmonth',
    label: '上个月',
  },
  {
    name: 'custom',
    label: '自定义',
  },
  ],
})

/* eslint-disable arrow-body-style */
export const SUMMARY_SUM = (getter) => (data) => {
  return data
    .map(t => {
      if (typeof getter === 'function')
        return +(getter(t) || 0) || 0
      return +(t[getter] || 0) || 0
    })
    // Sum up
    .reduce((a, b) => a + b, 0)
    .toFixed(2)
}

export const SUMMARY_PLAIN = (text) => () => text



// WEBPACK FOOTER //
// ./client/src/defines/_common.js